import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";

const ShipmentInfo = ({ order }) => {
  const { tracking_summary, tracking_manual, created_at, shipping_address } =
    order;
  const { trackingStatus: i18n, customStatus } = useSelector(
    (state) => state.settings
  );
  const { tracking_form, tracking_history } = useSelector(
    (state) => state.i18n
  );
  const address =
    typeof shipping_address === "string"
      ? JSON.parse(shipping_address)
      : shipping_address;
  const checkOrderNoInfo = () => {
    if (
      (tracking_summary === "courier_not_supported" &&
        tracking_manual === "courier_not_supported") ||
      (tracking_summary === "courier_not_supported" && !tracking_manual)
    ) {
      return true;
    }
    return false;
  };

  const { general: settings, reviewQuestions } = useSelector(
    (state) => state.settings
  );
  const checkString = (string) => (string ? string + ", " : "");
  const shippingAddress =
    checkString(address.address1) +
    checkString(address.address2) +
    checkString(address.city) +
    checkString(address.zip) +
    checkString(address.province) +
    checkString(address.country);

  const trackingStatus =
    tracking_summary === "courier_not_supported"
      ? tracking_manual ?? tracking_summary
      : tracking_summary;

  const listStatus = {
    courier_not_supported: 0,
    information_received: 1,
    pending: 2,
    available_for_pickup: 2,
    in_transit: 3,
    failed_attempt: 4,
    exception: 4,
    expired: 4,
    out_for_delivery: 4,
    delivered: 5,
  };

  const activeIndex = listStatus[trackingStatus] ?? null;

  const isActiveCustomStatus =
    Math.abs(moment(created_at).diff(moment(), "days")) >=
    +customStatus.timeActive;

  let status;
  if (activeIndex === null) {
    if (customStatus.enabled && isActiveCustomStatus) {
      status = customStatus.label;
    } else {
      status = i18n.ordered;
    }
  } else {
    status = i18n[trackingStatus];
  }

  return (
    <div className="omg-special-tracking-history">
      <div className="omg-section omg-special-tracking-history-section">
        <div className="omg-section__title">
          {tracking_history.shipment_information}
        </div>
        <div className="omg-section__content">
          <div className="omg-section">
            <div className="omg-section__content">
              <div className="omg-special-tracking-carrier">
                <div className="omg-special-tracking-carrier-name">
                  {tracking_history.shipping_address}:{" "}
                  <span style={{ fontWeight: "normal" }}>
                    {shippingAddress}
                  </span>
                </div>
                <div className="omg-special-tracking-carrier-name my-3">
                  {tracking_history.tracking_number}:{" "}
                  <span style={{ fontWeight: "normal" }}>
                    {order.tracking_number}
                  </span>
                </div>
                {settings.show.includes("tracking_company") && (
                  <div className="omg-special-tracking-carrier-name">
                    {tracking_history.carrier}:{" "}
                    <span style={{ fontWeight: "normal" }}>
                      {order?.tracking_company}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShipmentInfo;
